module.exports = __webpack_public_path__ + "img/control_de_calidad_9-16_360.126cfec8.jpg";